@if ((nodeSharedFacade.currentSelectedElearningNode$ | async); as elearningNode) {
  <div class="mdsf-carousel p-0 m-0 w-100">
    @if ((appSharedFacade.page$(elearningNode.page) | async); as page) {
      <!-- TODO IMAGE LOADER
      <medsurf-shared-image-loader *ngIf="(appSharedFacade.media$(page.media) | async) as media"
        [media]="media"
        [alt]="'Decorative Carousel Image'"
      [class]="'mdsf-carousel-image w-100 h-100'"></medsurf-shared-image-loader>
      -->
      @if ((appSharedFacade.media$(page.media) | async); as media) {
        <img class="mdsf-carousel-image w-100 h-100"
          [src]="mediaControlService.getUrl(media)"
          fill="true"
          priority
          alt="decorative Carousel image">
      }
    }
  </div>
}
